import {
  Box,
  Text,
  WizardStep,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'
import { F0Select } from '@factorialco/f0-react'
import { Input, Textarea } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import {
  TrainingsWizardData,
  TrainingsWizardDataField,
  validateMandatoryFields,
} from 'modules/finance/components/TrainingsBudgetWizard/lib/trainingsBudgetWizard'

const BasicDetailsStep = ({ data, onDataChanged }: WizardStepRenderParams<TrainingsWizardData>) => {
  const legalEntityOptions = data.legalEntities.map((legalEntity) => ({
    value: String(legalEntity.id),
    label: legalEntity.legalName ?? '',
  }))

  const handleNext = async () => {
    const mandatoryFields: TrainingsWizardDataField[] = ['name', 'legalEntityId']

    const { invalidFields, dataWithErrors } = validateMandatoryFields(mandatoryFields, data)

    onDataChanged(dataWithErrors)

    if (invalidFields.length) {
      return Promise.reject()
    }
  }

  useOnNext(handleNext)

  return (
    <Box gap="s40" flexDirection="column">
      <Box gap="s24" width="full">
        <Box gap="s8">
          <Text.Header2>
            {i18n.t('budgets.forms.trainings_budget.basic_details.title')}
          </Text.Header2>
          <Text.Normal>
            {i18n.t('budgets.forms.trainings_budget.basic_details.description')}
          </Text.Normal>
        </Box>
      </Box>
      <Box gap="s24" maxWidth="s600" flexDirection="column">
        {data.legalEntities.length > 1 && (
          <F0Select
            required
            value={data.legalEntityId ? String(data.legalEntityId) : undefined}
            label={i18n.t('budgets.forms.new_budget.basic_information.legal_entity')}
            options={legalEntityOptions}
            error={data.errors?.legalEntityId}
            onChange={(value: string) =>
              onDataChanged({
                ...data,
                legalEntityId: Number(value),
                currency: data.legalEntities.find((le) => le.id === Number(value))?.currency ?? '',
              })
            }
            size="md"
          />
        )}

        <Input
          required
          label={i18n.t('budgets.forms.new_budget.basic_information.budget_title')}
          onChange={(value) => onDataChanged({ ...data, name: value })}
          placeholder={i18n.t(
            'budgets.forms.new_budget.basic_information.budget_title_placeholder'
          )}
          value={data.name}
          error={data.errors?.name}
        />

        <Textarea
          label={i18n.t('budgets.forms.new_budget.basic_information.budget_description')}
          onChange={(value) => onDataChanged({ ...data, description: value })}
          placeholder={i18n.t(
            'budgets.forms.new_budget.basic_information.budget_description_placeholder'
          )}
          value={data.description}
          error={data.errors?.description}
        />
      </Box>
    </Box>
  )
}

export const basicDetailsStep = (): WizardStep<TrainingsWizardData> => ({
  title: i18n.t('budgets.forms.trainings_budget.basic_details.title'),
  nextText: i18n.t('common.next'),
  render: (props) => <BasicDetailsStep {...props} />,
  isCompleted: () => true,
})
